import { InvitationToken } from 'models';
import { useQuery } from 'query';
import { getInvitationToken } from '../services';
import { getInvitationTokenKey } from './keys';

export const useInvitationTokenQuery = (
  { invitationToken }: { invitationToken: string },
  options?: { throwOnError?: boolean },
) =>
  useQuery<InvitationToken>({
    async queryFn() {
      const { data } = await getInvitationToken(invitationToken);

      return new InvitationToken(data);
    },
    queryKey: getInvitationTokenKey({ invitationToken }),
    throwOnError: true,
    ...options,
  });
